/**
 * data-sw-search-overlay
 *
 * Used to trigger a focus on the search input in the top nav
 *
 */
var $ = require('js/sw-jquery/sw-jquery');

$(function () {
  $('body').on('click', '[data-sw-search-overlay]', function () {
    //A timeout must be set for the input to be focused on because there is a transition that happens when you click the search overlay.
    //We have to wait till the transition is complete to focus on the input.
    setTimeout(function () {
      $('[data-sw-top-nav-search-input]').focus();
    }, 300);
  });
});
